import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/sam_bo_luong.png";
import useMetaTracking from "../hooks/useMetaTracking";

function SamBoLuong() {
  useMetaTracking("ViewContent", {
    content_name: "Sam Bo Luong",
    content_category: "Vegan Menu",
    content_ids: ["sam_bo_luong"],
    content_type: "vegan_vietnamese_drinks",
    value: 7.0,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Sâm Bổ Lượng | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="A Vietnamese herbal dessert drink (Sâm Bổ Lượng) that's known for cooling down your body & boosting energy. Made with lotus seeds, longan, jujube (red dates), seaweed, snow jelly & more - it offers a delicate blend of natural sweetness & chewy textures in every cooling sip."
        />
        <meta
          property="og:title"
          content="Sâm Bổ Lượng | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="A Vietnamese herbal dessert drink (Sâm Bổ Lượng) that's known for cooling down your body & boosting energy. Made with lotus seeds, longan, jujube (red dates), seaweed, snow jelly & more - it offers a delicate blend of natural sweetness & chewy textures in every cooling sip."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Vietnamese Herbal Dessert"
          titleSubHead="$7.00 each"
          detailBody="A Vietnamese herbal dessert drink (Sâm Bổ Lượng) that's known for cooling down your body & boosting energy. Made with lotus seeds, longan, jujube (red dates), seaweed, snow jelly & more - it offers a delicate blend of natural sweetness & chewy textures in every cooling sip."
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default SamBoLuong;